module.exports = __webpack_public_path__ + "img/9.161fbda6.gif";